import React, { useState } from 'react';
import { useScrollAnimation } from './hooks/ScrollAnimation';
import { useTheme } from '../context/ThemeContext';
import GameSelection from './games/GameSelection';
import TargetClickerGame from './games/TargetClickerGame';
import MemoryMatchGame from './games/MemoryMatchGame';
import ReactionTestGame from './games/ReactionTestGame';
import TicTacToeGame from './games/TicTacToeGame';
import FlappyBirdGame from './games/FlappyBirdGame';
import SnakeGame from './games/SnakeGame';

const GameMenu = () => {
  const { isDark } = useTheme();
  const [activeGame, setActiveGame] = useState(null);

  const { ref: titleRef,   isVisible: titleVisible   } = useScrollAnimation({ threshold: 0.1 });
  const { ref: contentRef, isVisible: contentVisible } = useScrollAnimation({ threshold: 0.05 });

  const games = [
    { id: 'clicker',  name: 'Target Clicker', icon: '🎯',    description: 'Klik target, secepat yang kamu bisa!' },
    { id: 'memory',   name: 'Memory Match',   icon: '🧠',    description: 'Cocokan gambar yang sama'             },
    { id: 'reaction', name: 'Reaction Test',  icon: '⚡',    description: 'Tes kecepatan reaksimu'               },
    { id: 'tictactoe',name: 'Tic Tac Toe',    icon: '❌⭕',  description: 'Classic X & O game'                   },
    { id: 'snake',    name: 'Snake Game',     icon: '🐍',    description: 'Classic snake game'                   },
    { id: 'flappy',   name: 'Flappy Bird',    icon: '🐦',    description: 'Flappy bird'                          },
  ];

  const sectionBg  = isDark ? 'bg-[#060B14]' : 'bg-gray-50';
  const titleColor = isDark ? 'text-white'   : 'text-gray-800';
  const gameBg     = isDark ? 'bg-[#0D1520] border-[#1E3A5F]' : 'bg-white border-[var(--border-color)]';
  const backBtnBg  = isDark 
    ? 'bg-[#111C2C] text-slate-300 hover:bg-[#1E3A5F] border-[#1E3A5F]' 
    : 'bg-gray-600 text-white hover:bg-gray-700';

  return (
    <section id="game-zone" className={`py-10 md:py-16 px-4 transition-colors duration-300 ${sectionBg}`}>
      <div className="container mx-auto max-w-6xl">
        <div
          ref={titleRef}
          className="text-center mb-6 md:mb-8"
          style={{
            opacity: titleVisible ? 1 : 0,
            transform: titleVisible ? 'translateY(0)' : 'translateY(-24px)',
            transition: 'opacity 0.6s ease-out, transform 0.6s ease-out',
          }}
        >
          <h2 className={`text-2xl md:text-3xl font-bold ${titleColor} mb-2 pixel-font`}>
            <span className="glitch-text" data-text="GAME ZONE">GAME ZONE</span>
          </h2>
        </div>

        {!activeGame ? (
          <div
            ref={contentRef}
            style={{
              opacity: contentVisible ? 1 : 0,
              transform: contentVisible ? 'translateY(0)' : 'translateY(24px)',
              transition: 'opacity 0.6s ease-out 0.1s, transform 0.6s ease-out 0.1s',
            }}
          >
            <GameSelection games={games} onSelectGame={setActiveGame} isDark={isDark} />
          </div>
        ) : (
          <div
            ref={contentRef}
            className={`pixel-border ${gameBg} p-6 relative transition-colors duration-300`}
            style={{
              opacity: contentVisible ? 1 : 0,
              transform: contentVisible ? 'translateY(0)' : 'translateY(24px)',
              transition: 'opacity 0.5s ease-out, transform 0.5s ease-out',
            }}
          >
            <button
              onClick={() => setActiveGame(null)}
              className={`absolute top-4 right-4 pixel-button ${backBtnBg} px-3 py-1 text-sm font-mono z-10`}
            >
              ← BACK
            </button>
            {activeGame === 'clicker'   && <TargetClickerGame />}
            {activeGame === 'memory'    && <MemoryMatchGame />}
            {activeGame === 'reaction'  && <ReactionTestGame />}
            {activeGame === 'tictactoe' && <TicTacToeGame />}
            {activeGame === 'snake'     && <SnakeGame />}
            {activeGame === 'flappy'    && <FlappyBirdGame />}
          </div>
        )}
      </div>
    </section>
  );
};

export default GameMenu;